<template>
  <article
    class="px-6 py-4 flex flex-col bg-white border-grey-300 relative"
    :class="isLast ? 'border-b-0' : 'border-b-2'"
  >
    <div class="md:flex flex-1 items-center border-b mb-4 pb-4">
      <a
        :href="
          route('assessments.phases.application', [
            $page.funding_pot.id,
            $page.marking_phase.id,
            application.uuid
          ])
        "
        class="block text-grey-900 hover:text-primary-700 no-underline flex-1"
      >
        <h2 class="text-xl leading-tight truncate mb-1">
          <span
            v-if="application.stream && !isSingleStream"
            class="border rounded px-2 py-1 align-bottom text-sm inline-block leading-none mr-2"
            :style="getStreamColorsByKey(application.stream)"
          >
            {{ getStreamNameByKey(application.stream) }}
          </span>
          {{ application.user.company.name | sentencecase }}
        </h2>
        <p class="capitalize">{{ application.user.name }}</p>
      </a>
      <div class="flex mt-4 md:mt-0">
        <app-badge
          v-if="application.recommended"
          icon="star"
          type="neutral"
          class="mr-4 self-center"
        >
          Recommended
        </app-badge>
        <template v-if="application.total !== null">
          <p class="text-4xl font-bold" :class="gradingColorScore">
            {{ application.total }}/<small class="text-xl">{{
              application.max_score
            }}</small>
          </p>
        </template>
        <template v-else>
          <app-badge type="neutral" icon="important">
            Not Started
          </app-badge>
        </template>
      </div>
    </div>
    <div class="flex items-center">
      <app-badge v-if="application.grading_completed" icon="check" class="mr-2">
        {{ gradingLocked ? "Confirmed" : "Assessed" }}
      </app-badge>
      <p class="mr-2 text-sm text-grey-700 truncate flex-1">
        [{{ application.ref }}] {{ application.title }}
      </p>
      <div class="flex items-baseline ml-auto flex-no-shrink">
        <a
          class="text-xs text-left uppercase font-bold border px-2 py-1 text-primary-700 border-primary-500 hover:border-primary-700 hover:bg-primary-100 hover:text-primary-800 transition-all transition-normal no-underline ml-1"
          :href="
            route('assessments.phases.application', [
              $page.funding_pot.id,
              $page.marking_phase.id,
              application.uuid
            ])
          "
        >
          {{ gradingLocked ? "Review" : "Grade" }}
        </a>
        <a
          class="text-xs text-left uppercase font-bold border px-2 py-1 text-grey-500 border-grey-300 hover:border-primary-700 hover:bg-primary-100 hover:text-primary-800 transition-all transition-normal no-underline ml-1"
          :href="route('applications.pdf', { application: application.uuid })"
          target="_blank"
        >
          PDF
        </a>
        <a
          class="text-xs text-left uppercase font-bold border px-2 py-1 text-grey-500 border-grey-300 hover:border-primary-700 hover:bg-primary-100 hover:text-primary-800 transition-all transition-normal no-underline ml-1"
          :href="
            route('applications.download', {
              application: application.uuid
            })
          "
          target="_blank"
        >
          Download ZIP
        </a>
      </div>
    </div>
  </article>
</template>

<script>
import AppBadge from "../components/app/AppBadge.vue";
import { competitionStreamsMixin } from "../mixins/competitionStreams.js";
export default {
  name: "AssessmentItem",
  components: { AppBadge },
  mixins: [competitionStreamsMixin],
  props: {
    isLast: {
      type: Boolean,
      default: false
    },
    application: {
      type: Object,
      required: true
    }
  },
  computed: {
    gradingLocked() {
      return (
        this.$page.marking_phase.locked ||
        this.application.marking_phase_status.confirmed_at
      );
    },
    gradingColorScore() {
      if (!this.application.total || !this.application.max_score) {
        return "text-grey-500";
      }
      return {
        0: "text-grading-value-1",
        10: "text-grading-value-2",
        20: "text-grading-value-3",
        30: "text-grading-value-4",
        40: "text-grading-value-5",
        50: "text-grading-value-6",
        60: "text-grading-value-7",
        70: "text-grading-value-8",
        80: "text-grading-value-9",
        90: "text-grading-value-10",
        100: "text-grading-value-10"
      }[
        Math.floor((this.application.total / this.application.max_score) * 10) *
          10
      ];
    }
  }
};
</script>
